import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CardModel } from '@barthauer/abc/cards-view';
import { AbcCoreContainerService } from '@barthauer/abc/ui-components';
import { BceService } from './services/bce.service';

@Component({
  selector: 'bce-library',
  styleUrls: ['./bce.scss'],
  encapsulation: ViewEncapsulation.None,
  template:
    '@if (_cardModelData) {<abc-cards-view class="bce-library-container" [groupsCard]="_cardModelData" [rtlEnabled]="rtlEnabled"></abc-cards-view>}',
  providers: [AbcCoreContainerService],
  standalone: false,
})
export class BceComponent {
  @Input() rtlEnabled: boolean;
  public _cardModelData: CardModel;
  @Input() set cardModelData(data: CardModel) {
    this._cardModelData = data;
  }

  constructor(public bceService: BceService) {
    this.bceService.cardModelData.subscribe((data) => {
      this._cardModelData = data;
    });
  }
}
